/**
 * @components notice
 * @author 陈恩浩
 */

import React, { Component } from 'react'

import './index.scss'

class Notice extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <div className="notice">
        <div className="notice-inner">
          <div className="notice-img">
            <div className="notice-layout">
              <div className="notice-layout-wrap">
                <div className="notice-title">灯笼</div>
                <div className="notice-content">
                  中国灯笼又统称为灯彩，是一种古老的汉族传统工艺品。起源于2000多年前的西汉时期，每年的农历正月十五元宵节前后，人们都挂起象征团圆意义的红灯笼，来营造一种喜庆的氛围。
                </div>
                <div className="notice-info">
                  <div className="notice-left">
                    <div className="notice-teacher">
                      <span>主讲老师: 吴 娟</span>
                      <span>上课时间: 2020.5.26</span>
                    </div>
                    <div className="notice-addres">
                      上课地址：https://www.ihatoo.com/index
                    </div>
                  </div>
                  <div className="notice-right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Notice
